import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { changeTeam, fetchLoaderRun, setSetvices } from "../../actions";
import Server from "../Server";
import { connect } from "react-redux";

const styles = theme => ({
  root: {
    display: "flex"
  },
  formControl: {},
  group: {
    margin: `${theme.spacing.unit}px 0`,
    textAlign: "left"
  }
});

class RadioButtonsGroup extends React.Component {
  state = {
    value: this.props.ekipa
  };

  controller = new AbortController();

  handleChange = event => {
    this.setState({ value: event.target.value });
    this.controller.abort();
    this.controller = new AbortController();
    this.props.changeTeam(event.target.value).then(() => this.getServices());
    this.props.setSetvices(null, true);
  };

  getServices = () => {
    this.props.fetchLoaderRun(true);
    const ekipa = this.state.value;
    const data = new URLSearchParams(new FormData());
    data.append("ekipa", ekipa);
    fetch(Server.calculate, {
      body: data,
      method: "POST",
      mode: "cors",
      redirect: "follow",
      credentials: "include",
      signal: this.controller.signal
    })
      .then(response => response.json())
      .then(data => {
        this.props.fetchLoaderRun(false);
        this.props.setSetvices(data);
      })
      .catch(err => {
        console.log(err.message);
      });
  };

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    const { classes, langBase } = this.props;

    return (
      <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          <RadioGroup
            aria-label="Ekipa"
            name="ekipa"
            className={classes.group}
            value={this.state.value}
            onChange={this.handleChange}
          >
            <FormControlLabel
              value="1W"
              control={<Radio color="primary" />}
              label={langBase.il9n.$1w}
              labelPlacement="end"
            />
            <FormControlLabel
              value="2W"
              control={<Radio color="primary" />}
              label={langBase.il9n.$2w}
              labelPlacement="end"
            />
            <FormControlLabel
              value="1W1F"
              control={<Radio color="primary" />}
              label={langBase.il9n.$1w1f}
              labelPlacement="end"
            />
            <FormControlLabel
              value="2W1F"
              control={<Radio color="primary" />}
              label={langBase.il9n.$2w1f}
              labelPlacement="end"
            />
            <FormControlLabel
              value="1F"
              control={<Radio color="primary" />}
              label={langBase.il9n.$1f}
              labelPlacement="end"
            />
          </RadioGroup>
        </FormControl>
      </div>
    );
  }
}

RadioButtonsGroup.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  langBase: state.langBase,
  ekipa: state.ekipa
});

const mapDispatchToProps = dispatch => {
  return {
    changeTeam: ekipa => {
      return new Promise(resolve => {
        dispatch(changeTeam(ekipa));
        resolve();
      });
    },
    fetchLoaderRun: flag => dispatch(fetchLoaderRun(flag)),
    setSetvices: (flag, status) => dispatch(setSetvices(flag, status))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RadioButtonsGroup));
